export const getMetricSystemByCityId = cityId => {
  const stupidoo = [
    '463',
    '455',
    '426',
    '425',
    '424',
    '423',
    '422',
    '417',
    '392',
    '390',
    '389',
    '335',
    '334',
    '333',
    '330',
    '304',
    '303',
    '302',
    '294',
    '293',
    '288',
    '285',
    '282',
    '281',
    '273',
    '256',
    '248',
    '248',
    '198',
    '150',
    '145',
    '144',
    '142',
    '141',
    '140',
    '135',
    '134',
    '133',
    '132',
    '126',
    '124',
    '123',
    '122',
    '121',
    '120',
    '119',
    '118',
    '117',
    '103',
    '86',
    '60',
    '59',
  ]

  return stupidoo.includes(String(cityId)) ? 'us' : 'metric'
}
